import React from "react";
import Carousel from "react-multi-carousel";

export default function serviceTeamsComponents() {
  const responsiveTeams = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="services_content_teams mt-3">
      <div className="header">
        <h2 className="font-vietnam-600">Meet our beautiful team</h2>
        <label htmlFor="" className="font-vietnam-200-italic">
          Tim kami terdiri dari para profesional berpengalaman yang berdedikasi
          untuk <br /> memberikan solusi terbaik. Dengan keahlian di berbagai
          bidang teknologi, <br /> kami siap membantu Anda mencapai tujuan
          bisnis Anda.
        </label>
      </div>
      <div className="content">
        <Carousel
          responsive={responsiveTeams}
          autoPlaySpeed={4000}
          autoPlay={true}
          infinite={true}
          ssr={true}
          arrows={false}
        >
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_marketing.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">Marketing</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_server.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">Server</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_design.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">Design</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_seo.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">SEO</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_programing.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">Developer</h3>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
}
